if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    show(opener) {
      this.initLightbox();
      super.show(opener);
      this.showActiveMedia();
    }

    initLightbox() {
      if (this.lightboxReady) return;
      this.lightboxReady = true;
      const dialog = this.querySelector('[role="dialog"]');
      const content = this.querySelector('[role="document"]');
      const controls = document.createElement('div');
      controls.className = 'mc-lightbox-controls';
      controls.innerHTML = '<button type="button" class="mc-lightbox-prev" aria-label="Previous image">&#8592;</button><span class="mc-lightbox-count" role="status" aria-live="polite" aria-atomic="true"></span><button type="button" class="mc-lightbox-next" aria-label="Next image">&#8594;</button>';
      dialog.appendChild(controls);
      controls.querySelector('.mc-lightbox-prev').addEventListener('click', () => this.moveMedia(-1));
      controls.querySelector('.mc-lightbox-next').addEventListener('click', () => this.moveMedia(1));
      // Dawn closes media modals on any mouse pointerup. Keep controls and images interactive.
      dialog.addEventListener('pointerup', (event) => {
        event.stopPropagation();
        if (event.pointerType === 'mouse' && (event.target === dialog || event.target === content)) this.hide();
      });
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open') || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.moveMedia(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      content.addEventListener('touchstart', (event) => {
        this.swipeStart = event.touches.length === 1 && event.target.tagName === 'IMG'
          ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      content.addEventListener('touchmove', (event) => {
        if (event.touches.length !== 1) this.swipeStart = null;
      }, { passive: true });
      content.addEventListener('touchend', (event) => {
        if (!this.swipeStart) return;
        const dx = event.changedTouches[0].clientX - this.swipeStart.x;
        const dy = event.changedTouches[0].clientY - this.swipeStart.y;
        this.swipeStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) this.moveMedia(dx < 0 ? 1 : -1);
      }, { passive: true });
      content.addEventListener('touchcancel', () => { this.swipeStart = null; }, { passive: true });
    }

    showActiveMedia() {
      const id = this.openedBy.getAttribute('data-media-id');
      const items = Array.from(this.querySelector('[role="document"]').children).filter((item) => item.hasAttribute('data-media-id'));
      const selected = items.find((item) => item.dataset.mediaId === id);
      if (!selected) return;
      // Retain the selected shade plus shared slides; don't mix other hidden variant images into its gallery.
      const gallery = this.openedBy.closest('media-gallery');
      const galleryIds = new Set(Array.from(gallery?.querySelectorAll('.product__media-item') || []).map((item) => item.dataset.mediaId?.split('-').pop()));
      this.lightboxItems = items.filter((item) => item === selected || galleryIds.has(item.dataset.mediaId) || !item.classList.contains('product__media-item--variant'));
      this.selectMedia(this.lightboxItems.indexOf(selected));
    }

    moveMedia(direction) {
      if (!this.lightboxItems || this.lightboxItems.length < 2) return;
      this.selectMedia((this.lightboxIndex + direction + this.lightboxItems.length) % this.lightboxItems.length);
    }

    selectMedia(index) {
      const activeMedia = this.lightboxItems[index];
      if (!activeMedia) return;
      window.pauseAllMedia();
      this.lightboxIndex = index;
      this.querySelectorAll('[role="document"] > [data-media-id]').forEach((item) => {
        const active = item === activeMedia;
        item.classList.toggle('active', active);
        item.setAttribute('aria-hidden', String(!active));
      });
      if (activeMedia.tagName === 'IMG') activeMedia.loading = 'eager';
      const content = this.querySelector('[role="document"]');
      content.scrollTop = 0;
      content.scrollLeft = 0;
      this.querySelector('.mc-lightbox-count').textContent = `${index + 1} / ${this.lightboxItems.length}`;
      this.querySelector('.mc-lightbox-controls').hidden = this.lightboxItems.length < 2;
      const template = activeMedia.querySelector('template');
      if (activeMedia.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) activeMedia.loadContent();
    }
  });
}
